/* 🤖 this file was generated by svg-to-ts */
export const matIconUTurnRight: {
  name: 'u-turn-right';
  data: string;
} = {
  name: 'u-turn-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6 9v12h2V9c0-2.21 1.79-4 4-4s4 1.79 4 4v4.17l-1.59-1.59L13 13l4 4 4-4-1.41-1.41L18 13.17V9c0-3.31-2.69-6-6-6S6 5.69 6 9z"/></svg>`
};
